import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { css } from "@emotion/react";
import { FancyPrice, Price } from "@zapier/currency";
import { Colors, FormLabel, Margin, Radio, Spacer, Text, } from "@zapier/design-system";
const priceCardStyles = css `
  border: 1px solid ${Colors.neutral400};
  border-radius: 3px;
`;
export const BillingIntervalOption = ({ accountCurrency, amount, interval, isSelected, onSelect, }) => {
    const monthlyAmount = interval === "year" ? amount / 12 : amount;
    return (_jsxs(Fragment, { children: [_jsxs(FormLabel, { children: [_jsx(Radio, { checked: isSelected, name: "billing-interval-radio", onChange: onSelect, value: interval }), _jsxs(Text, { color: "neutral700", children: ["Pay ", interval, "ly"] })] }), _jsx(Spacer, { height: 5 }), _jsx("div", { css: priceCardStyles, children: _jsxs(Margin, { margin: 20, children: [_jsx(FancyPrice, { currency: accountCurrency, children: monthlyAmount }), _jsxs(Text, { color: "neutral700", type: "smallPrint1", children: ["per month /", " ", interval === "year" ? (_jsxs(Fragment, { children: [_jsx(Price, { currency: accountCurrency, children: amount }), " per year"] })) : ("month-to-month")] })] }) })] }));
};

// @zapier/upsells@5.0.1 (c64b11b3c)
